import { render, staticRenderFns } from "./LbPlaceOrderPro.vue?vue&type=template&id=8701d472&scoped=true&"
import script from "./LbPlaceOrderPro.vue?vue&type=script&lang=js&"
export * from "./LbPlaceOrderPro.vue?vue&type=script&lang=js&"
import style0 from "./LbPlaceOrderPro.vue?vue&type=style&index=0&id=8701d472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8701d472",
  null
  
)

export default component.exports